import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProductItemUpdateModalUI from './ProductItemUpdateModalUI.js'

class ProductItemUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // update product item
      submitted: false,
      // maker
      maker: '',
      makerUpdated: false,
      makerError: null,
      // item name
      name: '',
      itemNameUpdated: false,
      itemNameError: null,
      // category
      category: '',
      categoryUpdated: false,
      categoryError: null,
      // mrp
      mrp: '',
      priceUpdated: false,
      priceError: null
    }
  }

  render() {
    return (
      <ProductItemUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        inventoryItemList={this.props.inventoryItemList}
        // update mode
        updateMode={this.props.updateMode}
        // maker
        maker={this.state.maker}
        onMakerChange={(event) => {
          this.setState({
            maker: event.target.value,
            makerUpdated: true
          })
        }}
        makerError={this.state.makerError}
        setMakerError={(event) => { this.setState({ makerError: event.target.value }) }}
        makerUpdated = {this.state.makerUpdated}
        // item name
        name={this.state.name}
        onItemNameChange={(event) => {
          this.setState({
            name: event.target.value,
            itemNameUpdated: true
          })
        }}
        itemNameError={this.state.itemNameError}
        setItemNameError={(event) => { this.setState({ itemNameError: event.target.value }) }}
        itemNameUpdated = {this.state.itemNameUpdated}
        // category
        category={this.state.category}
        onCategoryChange={(event) => {
          this.setState({
            category: event.target.value,
            categoryUpdated: true
          })
        }}
        categoryError={this.state.categoryError}
        setCategoryError={(event) => { this.setState({ categoryError: event.target.value }) }}
        categoryUpdated = {this.state.categoryUpdated}
        // mrp
        mrp={this.state.mrp}
        onPriceChange={(event) => {
          this.setState({
            mrp: event.target.value,
            priceUpdated: true
          })
        }}
        priceError={this.state.priceError}
        setPriceError={(event) => { this.setState({ priceError: event.target.value }) }}
        priceUpdated = {this.state.priceUpdated}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  // componentDidUpdate(prevProps) {
  //   let inventoryItemList = []

  //   if (this.props.inventoryItemList) {
  //     inventoryItemList = this.props.inventoryItemList
  //     inventoryItemList = inventoryItemList.filter(product => product.selected)
  //   }

  //   if (inventoryItemList.length !== 1) {
  //     return
  //   }

  //   let prevProductItemList = []

  //   if (prevProps.inventoryItemList) {
  //     prevProductItemList = prevProps.inventoryItemList
  //     prevProductItemList = prevProductItemList.filter(product => product.selected)
  //   }

  //   if (!prevProps.inventoryItemList || prevProps.inventoryItemList && (prevProductItemList.length !== 1 || inventoryItemList[0].id !== prevProductItemList[0].id)) {
  //     this.setState({
  //       maker: inventoryItemList[0].maker,
  //       name: inventoryItemList[0].name,
  //       category: inventoryItemList[0].category,
  //       mrp: inventoryItemList[0].mrp
  //     })
  //   }
  // }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let id = this.props.inventoryItemList.filter(product => product.selected)[0].id

    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/inventoryItems/${id}`,
      this.onSubmitCallback, {
      maker: this.state.makerUpdated ? this.state.maker : this.props.inventoryItemList.filter(product => product.selected)[0].maker,
      name: this.state.itemNameUpdated ? this.state.name : this.props.inventoryItemList.filter(product => product.selected)[0].name,
      category: this.state.categoryUpdated ? this.state.category : this.props.inventoryItemList.filter(product => product.selected)[0].category,
      mrp: this.state.priceUpdated ? this.state.mrp : this.props.inventoryItemList.filter(product => product.selected)[0].mrp,
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'maker':
          this.setState({ makerError: error.message })
          break;
        case 'name':
          this.setState({ itemNameError: error.message })
          break;
        case 'category':
          this.setState({ categoryError: error.message })
          break;
        case 'mrp':
          this.setState({ priceError: error.message })
          break;
        default:
      }
    })

    if (response.errorList.length !== 0) {
      this.setState({
        errorList: errorList,
        submitted: false,
      })

      return;
    }

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)

    this.props.onUpdateComplete(response.product)

    this.setState({
      maker: '',
      name: '',
      category: '',
      mrp: '',
      makerUpdated: false,
      itemNameUpdated: false,
      categoryUpdated: false,
      priceUpdated: false
    })
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      makerError: null,
      itemNameError: null,
      categoryError: null,
      priceError: null,
      submitted: false,
      name: '',
      category: '',
      mrp: '',
      maker: '',
      makerUpdated: false,
      itemNameUpdated: false,
      categoryUpdated: false,
      priceUpdated: false
    })

    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update_product_item',
      'c_update',
      'c_cancel',
      'c_maker_name',
      'c_item_name',
      'c_category',
      'c_price'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('prd_itm_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(ProductItemUpdateModalSF)
